import { ReportTypeMap } from '../types'

export const getColumnGroupParent = <RT extends keyof ReportTypeMap>(
  columnId: ReportTypeMap[RT]['columnId'],
) => {
  return columnId.split('.')[0] as ReportTypeMap[RT]['groupId']
}
